export default "/images/framework/Badge_08.59f2055d.svg?59f2055d";